/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { totalSupplyGetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGet } from "../../funcs/totalSupplyGetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGetRequest$inboundSchema,
};

export const tool$totalSupplyGetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGet:
  ToolDefinition<typeof args> = {
    name: "total-supply-txt-v2",
    description: `Get the latest total supply value in plain text format.

Original tool name: txt-api-v2-ledgers-ledger-canister-id-total-supply-txt-get

### How is the data for this endpoint gathered?

Total supply is calculated by summing all mints and then subtracting all burns (including fees).`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await totalSupplyGetTotalSupplyTxtApiV2LedgersLedgerCanisterIdTotalSupplyTxtGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };